export default "__VITE_ASSET__AqD2qpMd__"